"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("util");

var eth_1 = require("../eth");

var SentContractTx = /*#__PURE__*/function (_eth_1$SentTransactio) {
  _inherits(SentContractTx, _eth_1$SentTransactio);

  function SentContractTx(eth, contractAbi, promise) {
    var _this;

    _classCallCheck(this, SentContractTx);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SentContractTx).call(this, eth, promise));
    _this.contractAbi = contractAbi;
    return _this;
  }

  _createClass(SentContractTx, [{
    key: "handleReceipt",
    value: function () {
      var _handleReceipt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(receipt) {
        var _this2 = this;

        var _receipt, logs, to, _receipt$contractAddr, contractAddress, isAnonymous, anonymousLogs, events;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _get(_getPrototypeOf(SentContractTx.prototype), "handleReceipt", this).call(this, receipt);

              case 2:
                receipt = _context.sent;
                _receipt = receipt, logs = _receipt.logs, to = _receipt.to, _receipt$contractAddr = _receipt.contractAddress, contractAddress = _receipt$contractAddr === void 0 ? to : _receipt$contractAddr;

                if (util_1.isArray(logs)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", receipt);

              case 6:
                isAnonymous = function isAnonymous(log) {
                  return !log.address.equals(contractAddress) || !_this2.contractAbi.findEntryForLog(log);
                };

                anonymousLogs = logs.filter(isAnonymous);
                events = logs.reduce(function (a, log) {
                  if (isAnonymous(log)) {
                    return a;
                  }

                  var ev = _this2.contractAbi.decodeEvent(log);

                  a[ev.event] = a[ev.event] || [];
                  a[ev.event].push(ev);
                  return a;
                }, {});
                delete receipt.logs;
                return _context.abrupt("return", _objectSpread({}, receipt, {
                  anonymousLogs: anonymousLogs,
                  events: events
                }));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleReceipt(_x) {
        return _handleReceipt.apply(this, arguments);
      }

      return handleReceipt;
    }()
  }]);

  return SentContractTx;
}(eth_1.SentTransaction);

exports.SentContractTx = SentContractTx;